import { render, staticRenderFns } from "./MegaMenuExpand.vue?vue&type=template&id=a738f826&"
import script from "./MegaMenuExpand.vue?vue&type=script&lang=js&"
export * from "./MegaMenuExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports